<template>
<div class="list">

    <div class="list-item" v-for="(item,index) in data" :key="index" @click="gotoDetails(item.action_status,item.id)">

        <div class="list-i" v-if="'action_status' in item" style="width:70vw">
            <span class="dot"></span>
            <span class="text">{{item.name||item.title}}</span>
        </div>
        <div class="list-i" v-else style="width:80vw">
            <span class="dot"></span>
            <span class="text">{{item.name||item.title}}</span>
        </div>
        <div v-if="'action_status' in item">{{item.action_status?' 活动已过期':'活动中'}}</div>
    </div>
</div>
</template>

<script>
export default {
    name: 'List',
    props: {

        data: Array,
        path: String,

    },
    data() {
        return {
            list: []
        }
    },
    methods: {
        gotoDetails(status, id) {
            if (status) {
                this.$router.push('')
            } else {
                this.$router.push(`${this.path}/${id}`)
            }
        }
    }
    

}
</script>

<style lang="less">
.list {
    border-top: 2px solid #f5dad1;
    margin-top: 20px;
    font-size: 28px;

    .list-item {
        border-bottom: 2px solid #f5dad1;
        height: 70px;
        padding-left: 50px;
        line-height: 70px;
        padding-right: 30px;
        color: #000;
        position: relative;
        display: flex;
        justify-content: space-between;
        .list-i{
            width: 70vw;
            
            .dot {
                display: block;
                width: 4px;
                height: 4px;
                background-color: #000;
                position: absolute;
                left: 50px;
                top: 50%;
                }

            .text {
                display: block;
                margin-left: 20px;
                overflow: hidden;
                text-overflow:ellipsis; 
                white-space: nowrap;
                width: 100%;
                }
        }
        
    }
}
</style>
